import { countries } from "resources/countries-config.json";

export const getSupportPhoneNumberByCountry = (country: string): string => {
  const customerNumber = countries[country].customerNumber;
  return customerNumber;
};
